import { Injectable } from "@angular/core";
import { InputParameter, InputType } from "@tylertech/tyler-api-types";

export type IParameterConfig = Omit<InputParameter, "Default" | "InputType" | "LookupProvider" | "Mask">;

@Injectable()
export class InputParameterService
{
    createBooleanParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Boolean, config);
    }

    createDateParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Date, config);
    }

    createDecimalParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Decimal, config);
    }

    createMetadataParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Metadata, config);
    }

    createNumberParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Number, config);
    }

    createSelectParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Select, config);
    }

    createTextParameter(config: IParameterConfig): InputParameter
    {
        const param = this.createParameter(InputType.Text, config);
        param.IsVisible = false;
        return param;
    }

    createTypeaheadParameter(config: IParameterConfig): InputParameter
    {
        return this.createParameter(InputType.Typeahead, config);
    }

    private createParameter(inputType: InputType, config: IParameterConfig): InputParameter
    {
        return Object.assign({ InputType: inputType }, config);
    }
}
